export const storeLinks = {
    apple_jama_app: "https://apps.apple.com/ec/app/jama-food-delivery/id1525620892",
    play_store_jama_app: "https://play.google.com/store/apps/details?id=com.arcandia.bees&hl=es_EC",
};
